var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF9500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3003_8253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 27.2001C30 27.6459 29.8353 27.9859 29.5058 28.2201C29.1764 28.4544 28.7721 28.5716 28.2929 28.5716H11.7071C11.2279 28.5716 10.8236 28.4516 10.4942 28.2116C10.1647 27.9716 10 27.6344 10 27.2001C10 26.8573 10.1078 26.5087 10.3235 26.1544L18.6074 12.3716C19.0027 11.743 19.4699 11.4287 20.009 11.4287C20.5481 11.4287 21.0033 11.743 21.3747 12.3716L29.6765 26.1716C29.8922 26.5373 30 26.8801 30 27.2001ZM21.2489 18.4401V15.9373H18.7511V18.4401C18.7511 18.6001 18.7631 18.7516 18.7871 18.8944C18.811 19.0373 18.844 19.1973 18.8859 19.3744C18.9278 19.5516 18.9608 19.703 18.9847 19.8287L19.4519 22.6059H20.5121L20.9973 19.8287C21.0213 19.7144 21.0572 19.5659 21.1051 19.383C21.153 19.2001 21.189 19.0373 21.2129 18.8944C21.2369 18.7516 21.2489 18.6001 21.2489 18.4401ZM21.2489 25.0744C21.2489 24.743 21.1261 24.463 20.8805 24.2344C20.6349 24.0059 20.3384 23.8916 19.991 23.8916C19.6556 23.8916 19.3651 24.0059 19.1195 24.2344C18.8739 24.463 18.7511 24.743 18.7511 25.0744C18.7511 25.4059 18.8739 25.6887 19.1195 25.923C19.3651 26.1573 19.6556 26.2744 19.991 26.2744C20.3384 26.2744 20.6349 26.1573 20.8805 25.923C21.1261 25.6887 21.2489 25.4059 21.2489 25.0744Z",
    fill: "#FF9500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3003_8253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.1429,
    fill: "white",
    transform: "translate(10 11.4287)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.a5c07e65d1c23b16762918f1b234307b.svg";
export { ForwardRef as ReactComponent };